import { addDays, addMonths, startOfDay, startOfMonth } from 'date-fns';
import { fromZonedTime, toZonedTime } from 'date-fns-tz';

/** Calendar boundaries for lead created_at queries in the business timezone. */
export function getBusinessLeadCreatedAtRanges(timezone: string) {
  const zonedNow = toZonedTime(new Date(), timezone);
  const monthStart = fromZonedTime(startOfMonth(zonedNow), timezone).toISOString();
  const nextMonthStart = fromZonedTime(
    startOfMonth(addMonths(zonedNow, 1)),
    timezone,
  ).toISOString();
  const todayStart = fromZonedTime(startOfDay(zonedNow), timezone).toISOString();
  const tomorrowStart = fromZonedTime(startOfDay(addDays(zonedNow, 1)), timezone).toISOString();
  const yesterdayStart = fromZonedTime(startOfDay(addDays(zonedNow, -1)), timezone).toISOString();

  return { monthStart, nextMonthStart, todayStart, tomorrowStart, yesterdayStart };
}
